import {proweb} from './proweb.js';

export var qas = {
    continueHasFocus: false,
    accountConfigManager: {},

    loadQas: function(formName, qasWrapperDiv, qasWidget, callback, qasAddress) {
        window.qas = {
            FORMNAME: formName,
            QASWRAPPERDIV: qasWrapperDiv,
            QASWIDGET: qasWidget,
            CALLBACK: callback
        };
        window.LINEONECTL = 'shippingAddress1';
        window.LINETWOCTL = 'shippingAddress2';
        window.CITYCTL = 'shippingCity';
        window.STATECTL = 'shippingState';
        window.ZIPCTL = 'shippingPostalCode';
        window.events.handleClickInputButton(qasAddress, qas.accountConfigManager);
        // console.log(proweb);
        // proweb.handleClickInputButton(qasAddress);
    },
    callQAS(qasAddress, qasCallback, accountConfigManager) {
        qas.accountConfigManager = accountConfigManager;
        qas.loadQas('forms.address', 'qasWrapper', 'qasWidget', qasCallback, qasAddress);
    },
    QAScalled(addresses) {
        addressList = addresses;
    }

}; 

    



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/qas.js
// module id = 174
// module chunks = 0